import React from 'react';
import Grid from "@material-ui/core/Grid";

import leftImage from '../../images/HowTo.png';
import abdtdotShape from '../../images/abdtdotshape.png';

import './style.scss';

const HowItWorks = () => {
    return(
        
        <Grid className="HowItWorksWrapper">
            <Grid
                container
                spacing={4}
                alignItems="center"
                className="container"
            >
                <Grid item xs={12} md={5}>
                    <Grid className="thumb">
                        <img src={leftImage} alt="leftImage"/>
                    </Grid>
                </Grid>
                <Grid item xs={12} md={7}>
                    <Grid className="introList">
                        <h2>How To</h2>
                        <p>We know why you’re here. You’re looking for a quick, simple, and affordable way to generate professional pay stubs for you and/or your team. You’ve come to the right place. Our approachable platform is all about ease of use and setting you up with everything you need and nothing more. Forget bells and whistles, you’re here for pay stubs and that’s what you’re going to get. Well ok, we include T4 reports and remittance summaries too, because you need those!
                           If you happen to get tripped up, this guide will help you navigate the process and the FAQs below will answer any questions you might have along the way. Here’s the scoop:
                         </p>
                    </Grid>
                </Grid>

            </Grid>
            <img src={abdtdotShape} alt="abdtdotShape" className="abdtdotShape"/>
        </Grid>
    )
};

export default HowItWorks;